import { SetStateAction } from "react";
import { stdObject } from "../../../data/types/stdObject";
import { saveCat } from "../functions/category/saveCat";
import { deleteCat } from "../functions/category/deleteCat";
import { colors } from "../../../data/colors";

export const catModal = ({
  t,
  dispatch,
  modalData,
  windowValues,
  setWindowValues,
  updateWindowValue,
  setMsg2,
  setModalData2,
  closeMsg,
  logoutAction,
  packUpdateWindow,
}: stdObject) => {
  return {
    title: modalData.title,
    mainColor: modalData.mainColor,
    blocked: true,
    tabs:
      modalData.id > 0
        ? [
            { code: 0, label: t("p.info") },
            { code: 1, label: t("p.subcategories") },
            { code: 2, label: t("p.items") },
            { code: 3, label: t("p.commissions") },
          ]
        : [],
    inputs: modalData.inputs?.map((e: stdObject) => {
      return {
        ...e,
        code: e.code,
        label: e.label,
        value: windowValues[e.code === "COMM" ? "commissions" : e.code],
        tabId: e.tabId,
        type: e.type,
        options: e.options,
        // style: { width: 300 },
        onChange: (v: { target: { value: SetStateAction<string> } }) =>
          updateWindowValue({
            code: e.code,
            value:
              e.type === "checkbox"
                ? Number(v.target.value)
                  ? 0
                  : 1
                : v.target.value,
            ...packUpdateWindow,
          }),
      };
    }),
    buttons: [
      {
        label: modalData.id === 0 ? t("p.create") : t("p.save"),
        onClick: () =>
          saveCat({
            t,
            dispatch,
            windowValues,
            setWindowValues,
            modalData,
            setMsg2,
            setModalData2,
            closeMsg,
            logoutAction,
          }),
        color: colors.green,
      },
      modalData.id > 0
        ? {
            label: t("p.delete"),
            onClick: () =>
              deleteCat(false, {
                t,
                dispatch,
                setWindowValues,
                modalData,
                setModalData2,
                setMsg2,
                closeMsg,
                logoutAction,
              }),
            color: colors.red,
          }
        : null,
      {
        label: t("p.cancel"),
        onClick: closeMsg,
        color: colors.darkGrey,
      },
    ],
  };
};
